import styled from 'styled-components';

const StampContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  background: #f1f1f1;
  border: 0.75px solid #e8e8e8;
  border-radius: 8px;
  padding: 3px 8px;
  color: #333333;

  > svg {
    margin-right: 10px;
  }
`;

const TooltipContent = styled.div``;

const TooltipText = styled.span`
  padding: 16px;

  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  display: flex;
  align-items: center;

  color: #333333;
`;

const StampWrapper = styled.div`
  display: flex;
  position: relative;

  &:hover {
    cursor: pointer;
  }
`;
export default StampContainer;
export { StampContainer, TooltipContent, StampWrapper, TooltipText };
